// api/user.ts
import { get } from "@/utils/request";

// 查询后台配置表
export const configs = () => { return get("/feishu/material-table/configs"); };
// 查询新闻配置表
export const getNewsList = (displayStatus) => { return get("/feishu/material-table/news", { displayStatus }); };
// 查询新闻配置表
export const getNavsList = () => get('/feishu/material-table/navs')
// 查询销售经理列表
export const getSalesManagers = () => get('/feishu/material-table/sales-managers')
// 查询发展历程列表
export const getCompanyProfiles = () => get('/feishu/material-table/company-profiles')
